import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { isEmpty } from 'lodash';
import Header from '../../components/Header';
import withNotify from '../../common/withNotify';
import withLoader from '../../common/withLoader';
import withGoBack from '../../common/withGoBack';
import withOnline from '../../common/withOnline';
import withCaseDer from '../../common/withCaseDer';
import Bugsnag from '../../helpers/bugsnag';
import {
  isStartsWithNumber,
  onGoBack
} from '../../common/globals';
import withTableName from '../../common/withTableName';
import withDersFilterResult from '../../common/withDersFilterResult';
import withSelectCaseId from '../../common/withSelectCaseId';
import withDersProduct from '../../common/withDersProduct';
import {
  getAllDers,
  getDersByDersNo,
  getTableCaseByCaseId,
  setDersData,
  updateDersById,
  updateTableWiseCaseByCaseId
} from '../../utils/db';
import DersRow from '../../components/DersRow';
import withViewDersDetails from '../../common/withViewDersDetails';
import withIsShowButtons from '../../common/withIsShowButtons';
import { updateDers } from '../../utils/utils';

class SearchResults extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dersList: []
    };
  }

  _onSearch = () => {
    try {
      this._onGoBack();
      browserHistory.push('/ders/search-ders/search-results');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onModify = () => {
    try {
      browserHistory.push('/ders/search-ders');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onAddNew = () => {
    try {
      const {
        goBack, setGoBack, setDersProducts,
        tableName, setTableName, setIsShowButtons
      } = this.props;
      setIsShowButtons({
        isView: false,
        isEdit: false,
        isCreate: true,
        isCopy: false,
        isSaved: false,
        isSubmitted: false
      });
      goBack.push(window.location.pathname);
      setGoBack(goBack);
      setTableName(tableName);
      setDersProducts([]);
      browserHistory.push('/ders/add-der');
      // browserHistory.push('/ders/add-non-case-der');
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onRedirect = (path, data) => {
    try {
      const { setIsShowButtons, setDersProducts } = this.props;
      setIsShowButtons({
        isView: true,
        isEdit: false,
        isCreate: false,
        isCopy: false,
        isSaved: false,
        isSubmitted: data.Submited === '1'
      });
      setDersProducts([]);
      this._onGoBack();
      browserHistory.push(path);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBackDers = () => {
    try {
      const { goBack, setDersFilterResults } = this.props;
      setDersFilterResults([]);
      onGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onGoBack = () => {
    try {
      const { goBack, setGoBack } = this.props;
      goBack.push(window.location.pathname);
      setGoBack(goBack);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _updateCaseList = (dersList) => {
    try {
      // const sortedList = orderBy(dersList, ['DateExplanted', 'DERNo'], ['desc', 'desc']);
      this.setState({
        dersList
      });
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  _onSubmit = async (derData) => {
    try {
      const {
        online, setLoader, notify, setDersFilterResults, caseDer, selectCaseId, tableName
      } = this.props;
      const derNoFlag = isStartsWithNumber(derData.DERNo);
      setLoader(true);
      if (online) {
        if (!derNoFlag) {
          notify({
            type: 'error',
            message: 'Something went wrong.',
            time: 3
          });
          setLoader(false);
          return;
        }
        derData.Submited = '1';
        const derNo = derData.DERNo;
        delete derData.DERNo;
        delete derData.ID;
        const responseJson = await updateDers(derNo, derData);
        const { status, data } = responseJson;
        if (status) {
          const dersData = await getDersByDersNo(derNo);
          await updateDersById(dersData.id, { ...data, id: dersData.id });
          if (caseDer === 'true') {
            const dersDetail = await getDersByDersNo(derNo);
            const caseDetailsRes = await getTableCaseByCaseId(selectCaseId, tableName);
            const caseDersRes = caseDetailsRes.case_ders;
            const filtered = caseDersRes.filter((el) => el.DERNo !== derNo);
            filtered.push(dersDetail);
            caseDetailsRes.case_ders = filtered;
            await updateTableWiseCaseByCaseId(
              caseDetailsRes.RepCaseNo, caseDetailsRes, tableName
            );
          }
          const dersList = await getAllDers();
          setDersFilterResults(dersList);
          await setDersData(dersList);
          await this._updateCaseList(dersList);
        }
        setLoader(false);
      } else {
        notify({
          type: 'error',
          message: 'You must have as internet connection. Please check your connection and try again.',
          time: 3
        });
        setLoader(false);
      }
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  async UNSAFE_componentWillMount() {
    try {
      const {
        params: { caseId }, tableName, dersFilterResult, setDersFilterResults,
        setViewDersDetails, setSelectCaseId
      } = this.props;
      let caseData = [];
      if (isEmpty(caseId)) {
        caseData = dersFilterResult;
      } else {
        const caseDetailsRes = await getTableCaseByCaseId(caseId, tableName);
        setDersFilterResults(caseDetailsRes.case_ders);
        caseData = caseDetailsRes.case_ders.map((item) => ({
          ...item,
          CaseNo: caseDetailsRes.CaseNo,
        }));
        setViewDersDetails(false);
        setSelectCaseId(caseId);
      }
      // Delete and add data DERs
      await setDersData(caseData);
      await this._updateCaseList(caseData);
    } catch (e) {
      Bugsnag.notify(e);
    }
  }

  render() {
    const { dersList } = this.state;
    const { caseDer, tableName } = this.props;
    return (
      <section className="list-section resizer-class">
        <Header
          actionButton={
            (caseDer === 'false')
              ? { title: 'Modify', onClick: this._onModify }
              : { title: 'ADD +', onClick: this._onAddNew }
          }
          title={(caseDer === 'false') ? 'Search Results' : 'DERs'}
          goBack={this._onGoBackDers}
        />
        <div className="search-result-top resizer-class row gx-2">
          <div className="col-12">
            <p className="pt-2 m-0">DERs: {dersList.length}</p>
          </div>
        </div>
        <section className="manage-session pb-2">
          <div className="container">
            {
              (dersList !== undefined && dersList.length > 0)
                ? dersList.map((data, key) => (
                  <DersRow
                    table={tableName}
                    key={key}
                    keyValue={key}
                    data={data}
                    onRedirect={this._onRedirect}
                    onSubmit={this._onSubmit}
                  />
                ))
                : <p className="der-no-result">No DERs have been added for this case.</p>
            }
          </div>
          {/* <div className="col-12 der-footer-section fixed-bottom resizer-class"> */}
          {/*  <div className="row gx-2"> */}
          {/*    <div className="col-12"> */}
          {/*      <p className="text-center m-0">DERs: {dersList.length}</p> */}
          {/*    </div> */}
          {/*  </div> */}
          {/* </div> */}
        </section>
      </section>
    );
  }
}

export default withSelectCaseId(
  withOnline(
    withGoBack(
      withNotify(
        withLoader(
          withCaseDer(
            withTableName(
              withViewDersDetails(
                withIsShowButtons(
                  withDersProduct(
                    withDersFilterResult(
                      SearchResults
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  )
);
